import { Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Team from "./pages/Team";
import Contact from "./pages/Contact";

// Admin
import AdminLayout from "./admin/AdminLayout";
import Dashboard from "./admin/Dashboard";
import ContentManager from "./admin/ContentManager";
import MediaManager from "./admin/MediaManager";
import ProductManager from "./admin/ProductManager";
import TeamManager from "./admin/TeamManager";
import EnquiryManager from "./admin/EnquiryManager";
import Settings from "./admin/Settings";
import Login from "./admin/Login";

function App() {
  return (
    <Routes>
      {/* Public Website */}
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="products" element={<Products />} />
        <Route path="team" element={<Team />} />
        <Route path="contact" element={<Contact />} />
      </Route>

      {/* Admin Panel */}
      <Route path="/admin/login" element={<Login />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="content" element={<ContentManager />} />
        <Route path="media" element={<MediaManager />} />
        <Route path="products" element={<ProductManager />} />
        <Route path="team" element={<TeamManager />} />
        <Route path="enquiries" element={<EnquiryManager />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

export default App;
